/**
 * @prop --vx-add-to-cart-button-background: The background color of the add to cart button
 * @prop --vx-add-to-cart-button-spinner-color: The color of the add to cart button spinner
 * @prop --vx-add-to-cart-button-spinner-filter: The filter of the add to cart button spinner
 * @prop --vx-add-to-cart-button-btn-add-flex: The flex value for the add container
 */
:host {
  --mdc-theme-primary: var(--vx-add-to-cart-button-background, #000);
  --mdc-theme-primary-background-color--hover: var(
      --mdc-button-primary-hover,
      #ea5659
  );
}

.vx-button-content {
  display: block;
}

.btn-add-wrapper.is--loading.has--focus .vx-button-content {
  display: none;
}

.btn-add-wrapper {
  display: flex;
  flex-direction: row;
}
.btn-add-wrapper vx-select {
  flex: 1;
}
.btn-add-wrapper .btn-add {
  flex: var(--vx-add-to-cart-button-btn-add-flex, 3);
}
.btn-add-wrapper .btn-add:hover {
  --mdc-theme-primary: var(
      --mdc-theme-primary-background-color--hover,
      #ea5659
  );
}

input.quantity-select {
  background: inherit;
  width: 64px;
  font-size: 1rem;
  line-height: 1rem;
}